import { useEffect, useState } from "react";

import { HiMagnifyingGlassPlus, HiMagnifyingGlassMinus } from "react-icons/hi2";

import { SmallTShirt } from "../../images";

import { capitalizeFirstWord, debounce } from "../../helpers";

import { useLoader, useShirtArea, useStep, useWindow } from "../../hooks";

import {
  Button,
  CustomSlider,
  LoaderComponent,
  UploadOptions,
} from "../decorate";

import DeviceUpload from "../upload";
import { CustomEditor } from "../editor";

function AdjustLogo({
  partsStep,
  getTexture,
  shirtImgRef,
  bgRemovedUrl,
  setPartsStep,
  setUploadType,
  removeBackground,
  partsUploadPreference,
  setPartsUploadPreference,
  currentPart,
  zoomValue,
  setZoomValue,
  zoom,
  setZoom,
  setCurrentPart,
  handleZoom,
}) {
  const [isPreviewing, setPreviewing] = useState(false);
  const [imageLoading, setImageLoading] = useState(null);
  const [isZooming, setIsZooming] = useState(false);

  const { step, deviceStep } = useStep();
  const { onLoader, offLoader } = useLoader();
  const onZoom = () => setIsZooming(!isZooming);

  // const handleZoom = (value, baseSliderValue) => {
  //   setZoomValue(value);

  //   const { height, width } = zoom;

  //   // Calculate the scaling ratio relative to the base slider value
  //   const ratio = value / baseSliderValue;

  //   // Calculate the new dimensions based on the ratio
  //   const finalWidth = Number(width) * ratio;
  //   const finalHeight = Number(height) * ratio;

  //   const logo_dimention = { height: finalHeight, width: finalWidth };

  //   setCurrentPart({
  //     ...currentPart,
  //     logo_dimention,
  //     zoomValue: value,
  //   });

  //   const data = { ...partsStep };
  //   data[`step${step}`].logo_dimention = logo_dimention;
  //   data[`step${step}`].zoomValue = value;
  //   setPartsStep(data);
  // };

  const onPartSelect = (data = null) => {
    if (data) {
      setCurrentPart(data);
    }
    setIsZooming(false);
  };
  const onAdjustLogo = (data) => {
    setCurrentPart({ ...data });
    setPreviewing(false);
    setZoomValue(data?.zoomValue || 100);
  };

  const onPreview = debounce(() => {
    setPreviewing(true);
    setCurrentPart({ ...(Object.values(partsStep || {})?.[0] || {}) });
  }, 200);

  useEffect(() => {
    const locationSteps = { ...partsStep };
    const data = locationSteps?.[`step${step}`] || null;
    if (data) {
      onAdjustLogo(data);
    } else {
      onPreview();
    }
    setZoom({ ...(data?.temp_dimention || {}) });
  }, [step, partsStep, setCurrentPart, setZoom, setZoomValue]);

  useEffect(() => {
    onLoader();
    setImageLoading(true);
    setIsZooming(false);
  }, [step]);

  return (
    <>
      <div className={"row"}>
        <div className="col-xl-12 text-center">
          {!isPreviewing && (
            <div className="logo-place">
              <h2>Adjust Logo Size</h2>
            </div>
          )}
        </div>
        <Preview
          props={{
            zoom,

            deviceStep,
            currentPart,
            onPartSelect,
            bgRemovedUrl,
            isPreviewing,
            getTexture,
            setUploadType,
            setCurrentPart,
            removeBackground,
            setPartsStep,
            step,
            partsStep,

            zoomValue: currentPart?.zoomValue || zoomValue,
            setZoom,
            setZoomValue,
            partsUploadPreference,
            setPartsUploadPreference,
            handleZoom,
          }}
          component={
            <ZoomInto
              {...{
                zoom,
                zoomValue,
                currentPart,
                isPreviewing,
                onPartSelect,
                bgRemovedUrl,
                shirtImgRef,
                imageLoading,
                setImageLoading,
                offLoader,
                isZooming,
                onZoom,
              }}
            />
          }
        />
      </div>
    </>
  );
}

export default AdjustLogo;

const Preview = ({ props, component }) => {
  const {
    isPreviewing,
    currentPart = {},
    setCurrentPart,
    removeBackground,
    getTexture,
    step,
    partsStep,
    setPartsStep,
    setZoom,
    setZoomValue,
    partsUploadPreference,
    setPartsUploadPreference,
    zoomValue,
    handleZoom,
  } = props;

  const {
    temp_url,
    logo_url,
    showedBgRemovedUrl,
    bgRemovedUrl,
    isBgRemoved = true,
    header,
    key,
    cropped_url,
  } = currentPart;

  const { isLoading } = useLoader();

  const finalAreaStyle = isPreviewing
    ? {}
    : { backgroundColor: "transparent", boxShadow: "none", margin: 0 };
  // Reset selection and upload type
  const handleResetSelection = () => {
    setPartsUploadPreference(null);
  };

  const updateTextureData = (
    image,
    dimension,
    bgRemovedFlag,
    mainImage,
    logoType = null,
  ) => {
    const data = {
      ...currentPart,
      texture_logo_url: image,
      text_url: mainImage,
      logo_dimention: dimension,
      temp_dimention: dimension,
      isBgRemoved: bgRemovedFlag,
      zoomValue: 100,
      type: logoType === "text" ? "text" : "logo",
    };

    setCurrentPart(data);
    setPartsStep({ ...(partsStep || {}), [`step${step}`]: data });
    setZoom(dimension);
    setZoomValue(100);
  };

  const handleGetTexture = (url, bgRemovedFlag, logoType = null) => {
    getTexture(
      url,
      (image, dimension, mainImage) => {
        updateTextureData(image, dimension, bgRemovedFlag, mainImage, logoType);
      },
      bgRemovedFlag,
    );
  };
  // Props for the device upload component
  const deviceUploadProps = {
    ...props,
    logo_url: temp_url || logo_url,
    cropped_url,
    showedBgRemovedUrl,
    bgRemovedUrl,
    isBgRemoved,
    setSelected: handleResetSelection,
    handleUrls: ({ logo_url, cropped_url }) => {
      setCurrentPart({
        ...currentPart,
        ...(logo_url ? { temp_url: logo_url } : {}),
        cropped_url: logo_url || cropped_url,
        isBgRemoved: null,
      });
    },
    removeBackground: (url) => {
      removeBackground(url, (transparent, croppedTransparent) => {
        setCurrentPart({
          ...currentPart,
          showedBgRemovedUrl: transparent,
          bgRemovedUrl: croppedTransparent,
        });
      });
    },
    getTexture: (url, cb, bgRemovedFlag) => {
      handleGetTexture(url, bgRemovedFlag);
    },
  };

  // Components for the different upload types
  const components = {
    text: (
      <CustomEditor
        id={currentPart?.key}
        setUrl={(url) => {
          removeBackground(
            url,
            (transparent, croppedTransparent) => {
              handleGetTexture(croppedTransparent, isBgRemoved, "text");
            },
            isBgRemoved,
          );
        }}
      />
    ),
    device: <DeviceUpload {...deviceUploadProps} />,
    gallery: <DeviceUpload {...{ isGallery: true, ...deviceUploadProps }} />,
  };

  return (
    <>
      <div
        className={`col-lg-${isPreviewing ? 9 : 7} ${
          isPreviewing ? "mb-2" : ""
        }`}
      >
        <div
          className={!isPreviewing ? "final-area" : ""}
          style={{ ...finalAreaStyle }}
        >
          <div
            className={!isPreviewing ? "final-img" : "preview-area"}
            style={{
              ...(isPreviewing
                ? { borderRadius: 0 }
                : {
                    height: 450,
                    width: 430,
                  }),
            }}
          >
            {component}
          </div>
        </div>
        {!isPreviewing && (
          <div style={{ width: "100%", padding: "0px 5px" }}>
            <CustomSlider
              max={Number(currentPart?.logo_max_width)}
              min={Number(currentPart?.logo_min_width)}
              value={zoomValue}
              onChange={handleZoom}
              stepDifference={currentPart?.logo_max_width == 290 ? 20 : 10}
              isDisabled={isLoading}
            />
          </div>
        )}
      </div>

      {!isPreviewing && (
        <div className="col-lg-5">
          <Selection header={header} label={key} />
          {partsUploadPreference === null ? (
            <div className="try-different-logo-section">
              <label
                className="mb-3"
                style={{ fontWeight: 500, fontSize: 18, color: "#666666" }}
              >
                Try a different logo?{" "}
                <label style={{ fontSize: 14 }}>
                  (for this selected location)
                </label>
              </label>
              <UploadOptions
                className="upload-option-row"
                setSelected={(val) => {
                  setPartsUploadPreference(val);
                }}
              />
            </div>
          ) : (
            <>{components[partsUploadPreference]}</>
          )}
        </div>
      )}

      {isPreviewing && (
        <div className="col-lg-3">
          <ShirtParts {...props} />
        </div>
      )}
    </>
  );
};

const ZoomInto = ({
  currentPart,
  isPreviewing,
  shirtImgRef,
  zoomValue = 0,
  imageLoading,
  isZooming,
  setImageLoading = () => {},
  offLoader = () => {},
  onZoom = () => {},
}) => {
  const { windowSize } = useWindow();
  const { isWhite } = useShirtArea();

  return (
    <LoaderComponent>
      {" "}
      <div
        ref={shirtImgRef}
        className={!isPreviewing ? "right-chest-full" : "preview-section-image"}
        style={{
          ...(isPreviewing
            ? { borderRadius: 0, margin: 0 }
            : {
                transformOrigin:
                  windowSize?.width < 500 &&
                  currentPart?.box_dimension?.width !==
                    currentPart?.box_dimension?.height
                    ? "52.5% 20%"
                    : currentPart?.transformOrigin,
                width: "400px",
                transform:
                  currentPart?.shirt_scale && !isPreviewing
                    ? `scale(${currentPart?.shirt_scale})`
                    : undefined,
                margin: 0,
              }),
        }}
      >
        <img
          src={!isPreviewing ? currentPart?.url : currentPart?.preview_url}
          alt=""
          onLoad={() => {
            setImageLoading(false);
            offLoader();
          }}
          style={{
            ...(isPreviewing
              ? {
                  transformOrigin: currentPart?.transformOrigin,
                  transition: "transform 300ms ease",
                  ...(isZooming
                    ? {
                        transform: "scale(2)",
                      }
                    : {}),
                }
              : {}),
          }}
        />
        {imageLoading === false && !isPreviewing && (
          <div
            className="logo-container"
            style={{
              transform: `scale(${currentPart?.logo_scale})`,
              ...(currentPart?.logo_position ? currentPart?.logo_position : {}),
            }}
          >
            <div className="logo-box">
              <div
                className={`d-flex ${currentPart?.box_dimension?.align} justify-content-center`}
                style={{
                  height: `${currentPart?.box_dimension?.height}px`,
                  width: `${currentPart?.box_dimension?.width}px`,
                }}
              >
                <div
                  className="logo"
                  style={{
                    height: `${currentPart?.logo_dimention?.height}px`,
                    minWidth: `${currentPart?.logo_dimention?.width}px`,
                    margin: 0,
                  }}
                >
                  <img
                    id="main-img"
                    alt=""
                    src={currentPart?.texture_logo_url}
                    style={{
                      height: "100%",
                      width: "100%",
                    }}
                  />
                  {/* Top horizontal scale */}
                  <div className="scale scale-top">
                    <div className="line-segment"></div>
                    <span
                      className="label"
                      style={{ ...(!isWhite ? { color: "white" } : {}) }}
                    >
                      {currentPart?.logo_dimention?.width + " mm"}
                    </span>
                    <div className="line-segment"></div>
                  </div>
                  {/* Right vertical scale */}
                  <div className="scale scale-right">
                    <div className="line-segment"></div>
                    <span
                      className="label"
                      style={{ ...(!isWhite ? { color: "white" } : {}) }}
                    >
                      {getMilimeterHeight(
                        currentPart?.logo_max_height,
                        currentPart?.logo_max_width,
                        currentPart?.logo_dimention?.height,
                        currentPart?.logo_dimention?.width,
                        zoomValue,
                      )}
                    </span>
                    <div className="line-segment"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {isPreviewing && (
          <div className="zoom-btn">
            <Button
              style={{ border: "none" }}
              icon={
                !isZooming ? (
                  <HiMagnifyingGlassPlus style={{ color: "black" }} />
                ) : (
                  <HiMagnifyingGlassMinus style={{ color: "black" }} />
                )
              }
              onClick={onZoom}
            />
          </div>
        )}
      </div>
    </LoaderComponent>
  );
};

const ShirtParts = ({ onPartSelect, partsStep, currentPart = {} }) => {
  return (
    <div className="final-right">
      {Object.values(partsStep)?.map((item, i) => (
        <div className="final-overview" onClick={() => onPartSelect(item)}>
          <div
            className="overview-img"
            style={{
              position: "relative",
              border:
                currentPart?.key === item.key ? "1px solid black" : "none",
              borderRadius: 10,
              cursor: "pointer",
            }}
          >
            <LoaderComponent />
            <img src={item?.preview_url} alt="" />
          </div>

          <p>{capitalizeFirstWord(item.key)}</p>
        </div>
      ))}
    </div>
  );
};

const Selection = ({ header, label = "" }) => {
  // Split the label to check if it has position information (e.g., "chest_left", "chest_center")
  const keys = label.split("_");
  const hasPositionInfo = keys.length > 1;
  const baseLabel = keys[0];
  const position = keys.length > 1 ? keys[1] : "";

  // Capitalize the label
  const capLabel = capitalizeFirstWord(baseLabel);
  const checkKey = (baseLabel || "").toLowerCase();

  // Option labels based on position
  const leftOption = `Left ${capLabel}`;
  const rightOption = `Right ${capLabel}`;
  const centerOption = `${capLabel} Center`;
  const singleOption = capLabel === "Back" ? "Shoulder Blades" : capLabel;

  // Check if the position is "center"
  const isCenter = position === "center";

  return (
    <div className="select-by-one-area upload-area">
      <div className="select-location">
        <img src={SmallTShirt} style={{ height: 25 }} alt="Small T-Shirt" />
        <span
          className="mb-0 text-muted"
          style={{ fontSize: 20, fontWeight: 600 }}
        >
          Selected {capitalizeFirstWord(header)}
        </span>
      </div>
      <div
        className="select-place text-center mb-2"
        style={{
          border: "1.5px solid black",
          boxShadow: "none",
        }}
      >
        <label style={{ fontSize: 18, fontWeight: 500, color: "#0A1324" }}>
          {capLabel}
        </label>
        {hasPositionInfo ? (
          isCenter ? (
            // Center option
            <div className="d-flex justify-content-center">
              <button
                className={`custom-select-btn selection-btn ${
                  label === `${checkKey}_center` ? "activeChest" : ""
                }`}
                style={{
                  cursor: "default",
                }}
              >
                {centerOption}
              </button>
            </div>
          ) : (
            // Left/Right options
            <div className="d-flex justify-content-between gap-2">
              <button
                className={`custom-select-btn selection-btn ${
                  position === "left" ? "activeChest" : ""
                }`}
                style={{
                  cursor: "default",
                }}
              >
                {leftOption}
              </button>
              <button
                className={`custom-select-btn selection-btn ${
                  position === "right" ? "activeChest" : ""
                }`}
                style={{
                  cursor: "default",
                }}
              >
                {rightOption}
              </button>
            </div>
          )
        ) : (
          // Single option (no position)
          <div className="d-flex justify-content-center">
            <button
              className={`custom-select-btn selection-btn ${
                label === checkKey ? "activeChest" : ""
              }`}
            >
              {singleOption}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

function getMilimeterHeight(logoMaxHeight, logoMaxWidth, height) {
  return `${height} mm`;
}
